import { CseMaterialModel, CseMaterialModelFromJson, JsonCseMaterialModel } from '../low-level/cse-material.model';
import { ArrayModelOptions, ArrayModelOptionsFromJson, JsonArrayModelOptions } from '../options/array-model-options';
import { ArrayModel, ODataArrayOutModel } from './array.model';

export class CseMaterialListModel extends ArrayModel<CseMaterialModel> {
    public constructor(
        name: string,
        entries: CseMaterialModel[],
        public options = new ArrayModelOptions(),
    ) {
        super(name, entries, options);
    }

    /**
     * Iterate over internal models array and call outmodel conversion function for each of the models
     *
     * @returns {object} the outmodel representation of this array model
     */
    public getOutModel(): ODataCseMaterialListOutModel {
        const outModel: ODataCseMaterialListOutModel = {};
        outModel[this.name] = this.value
            .filter((selectedEntry) => selectedEntry && !selectedEntry.isHidden)
            .map((entry) => entry.getOutModel());

        // extract first property of outModel so we don't return a nested outmodel
        return outModel;
    }
}

export class CseMaterialListModelFromJson extends CseMaterialListModel {
    public constructor(data: JsonCseMaterialListModel) {
        super(
            data.name,
            data.value.map((e) => {
                return new CseMaterialModelFromJson(e);
            }),
            new ArrayModelOptionsFromJson(data.options),
        );
    }
}

export interface JsonCseMaterialListModel {
    name: string;
    value: JsonCseMaterialModel[];
    options: JsonArrayModelOptions;
}

// need here type because empty interfaces are not allowed
export type ODataCseMaterialListOutModel = ODataArrayOutModel;
